export const buildGreeting = (nome: string | undefined): string => {
  const firstName = nome?.split(' ')[0] || '';
  const hour = new Date().getHours();
  const period = hour < 12 ? 'Bom dia' : hour < 18 ? 'Boa tarde' : 'Boa noite';
  return firstName ? `${period}, ${firstName}` : period;
}
